module.exports = __webpack_public_path__ + "static/media/DanKenney.47114424.jpg";